export const animationTimingFast = 0.25;
export const animationTimingSlow = 0.5;
export const smallMedia = 375;
export const largeMedia = 750;
export const tallBannerHeight =
  /* breakpoint */ 100 - /* padding-top */ 8 - /* padding-bottom */ 8;

export const AppDefId = 'f105ba16-6b7a-4b52-a2e5-712bdc749f76';

export const euCountryCodes = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'EL',
  'HU',
  'IS',
  'IE',
  'IT',
  'LV',
  'LI',
  'LT',
  'LU',
  'MT',
  'NO',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'GB',
];

export const translationKeys = {
  policyExternalUrl: 'policy.external.url',
  viewPrivacyPolicy: 'view.privacy.policy',
  policyBannerText: 'policy.banner.text',
  openSettingsButton: 'open.settings.button',
  declineCookiesButton: 'decline.all.button',
  acceptCookiesButton: 'accept.cookies.button',
  revisitSettingsButton: 'revisit.settings.text',
  advancedCategoryEssentialHeadline: 'advanced.category.essential.headline',
  advancedCategoryEssentialParagraph: 'advanced.category.essential.paragraph',
  essentialTooltip: 'essential.tooltip',
  displaySaveDefault: 'display.save.default',
  advancedCategoryMarketingHeadline: 'advanced.category.marketing.headline',
  advancedCategoryMarketingParagraph: 'advanced.category.marketing.paragraph',
  advancedCategoryFunctionalHeadline: 'advanced.category.functional.headline',
  advancedCategoryFunctionalParagraph: 'advanced.category.functional.paragraph',
  advancedCategoryAnalyticsHeadline: 'advanced.category.analytics.headline',
  advancedCategoryAnalyticsParagraph: 'advanced.category.analytics.paragraph',
};

export const CookieBannerPreviewSettingsChannel =
  'cookie_banner_preview_settings';
export const CookieBannerPreviewSettingsUpdateEvent = 'preview_settings_update';

export const fontCssBaseUrl =
  '//serverless.parastorage.com/cookie-consent-settings-serverless/font?family=';

export const consentPolicyUpdateRequestedEvent = 'consentPolicyUpdateRequested';
